


export type FlowUiModule = 'BillHeader' | 'Supplier';

export const FlowUiModule = {
    BillHeader: 'BillHeader' as FlowUiModule,
    Supplier: 'Supplier' as FlowUiModule
};

